module.exports = __webpack_public_path__ + "media/images/badge-pretty-978de94fe7c99a7ca544771be5b25e3f.jpeg";